import React from 'react';
import List from './components/list';

import './css/App.css';

function App() {
  return (
    <div className="App">
      <List />
    </div>
  );
}

export default App;
